import { Button, Col, Image, message, Row } from "antd";
import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { useCurrentUser } from "../actions/auth";
import QurealSection from "../common/QurealSection";
import SectionHeader from "../components/commons/SectionHeader";
import CreationFromLinkBox from "../content_calender_new/CreationFromLinkBox";
import IdeaCanvasBox from "../content_calender_new/IdeaCanvasBox";
import SocialMediaModal from "../social_media/SocialMediaModal";
import ThemeGenerator from "./ThemeGenerator";
import FontPicker from "../components/commons/FontPicker";
import ContentGenerator from "../content_calender_new/CalendarOutline";
import Tweet from "../linkedin_posts/TweetPost";
import EditorImagePicker from "../editor/imagepicker/ImagePicker";
import GenerationLoading from "../qmade/creator/GenerationLoading";
import NewGenerationLoading from "../qmade/creator/NewGenerationLoading";

function Sandbox2({ me }) {
    const { data: dataMe } = useCurrentUser();
    const location = useLocation();
    const searchParams = useMemo(
        () => new URLSearchParams(location.search),
        [location.search],
    );
    const status = searchParams.get("status");
    const msg = searchParams.get("msg");

    const [open_canvas, setOpenCanvas] = useState(false);
    const [singleSelectedImages, setSingleSelectedImages] = useState([]);
    const [multipleSelectedImages, setMultipleSelectedImages] = useState([]);

    const selected_org = dataMe?.selected_org?.id;
    const user_id = dataMe?.id;
    const encodedState = useMemo(
        () =>
            encodeURIComponent(
                JSON.stringify({
                    user_id,
                    org_id: selected_org,
                    return_url: window.location.href,
                }),
            ),
        [user_id, selected_org],
    );

    useEffect(() => {
        if (status === "success" && msg) {
            message.success(msg);
        } else if (status === "error" && msg) {
            message.error(msg);
        }
    }, [status, msg]);

    return (
        <QurealSection header={<SectionHeader heading="Qureal Sandbox" />}>
            <div style={{ padding: "15px" }}>
                <Button>
                    <a
                        href={`https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=77c99lfcwqw0ih&redirect_uri=https://botapi.qureal.com/social/linkedin/callback&scope=openid%20profile%20email%20w_member_social&state=${encodedState}`}
                    >
                        Connect LinkedIn
                    </a>
                </Button>
                <Button>
                    <a
                        href={`https://www.instagram.com/oauth/authorize?force_reauth=false&client_id=1430244024776272&redirect_uri=https://botapi.qureal.com/social/instagram/callback&response_type=code&scope=instagram_business_basic,instagram_business_content_publish&state=${encodedState}`}
                    >
                        connect instagram
                    </a>
                </Button>

                <CreationFromLinkBox
                    trigger={<Button>From Link</Button>}
                    me={dataMe}
                />

                <SocialMediaModal
                    trigger={<Button>Connect Your Social Media</Button>}
                />

                <Button onClick={() => setOpenCanvas(true)}>Test Canvas</Button>

                <IdeaCanvasBox
                    key="this_is_key"
                    open={open_canvas}
                    setOpen={setOpenCanvas}
                    loading={false}
                    me={me}
                    data={{
                        status: "generated",
                        generated_data: {
                            canvas: {
                                design: {
                                    template_id:
                                        "6d706e1b-215a-4d18-bf7b-6594e62abc4e",
                                    prefill: {
                                        ad_copy: {
                                            success: true,
                                            data: {
                                                one_liner:
                                                    "Experience Space Today!",
                                                product_line:
                                                    "Blue Origin's Space Tour",
                                                short_description:
                                                    "Join us for an unforgettable journey beyond Earth. Get ready for breathtaking views and the thrill of zero gravity!",
                                                cta: "Book Now",
                                            },
                                            post_processing: {},
                                        },
                                    },
                                    preset_id:
                                        "5b5cf63b-f71f-46ce-94f9-585c55bb52e4",
                                },
                            },
                        },
                    }}
                />

                <div style={{ marginTop: 16 }}>
                    <h3>PhotoTab Image Selection</h3>
                    <div style={{ marginBottom: 16 }}>
                        <EditorImagePicker
                            trigger={
                                <Button size="medium">
                                    Select Single Image
                                </Button>
                            }
                            many={false}
                            defaultTab="unsplash"
                            onSelect={(images) => {
                                message.success(
                                    `Selected ${images.length} image from PhotoTab`,
                                );
                                setSingleSelectedImages(images);
                            }}
                        />
                        <EditorImagePicker
                            trigger={
                                <Button size="medium" style={{ marginLeft: 8 }}>
                                    Select Multiple Images
                                </Button>
                            }
                            many={true}
                            defaultTab="unsplash"
                            onSelect={(images) => {
                                message.success(
                                    `Selected ${images.length} images from PhotoTab`,
                                );
                                setMultipleSelectedImages(images);
                            }}
                        />
                    </div>
                    {(singleSelectedImages.length > 0 ||
                        multipleSelectedImages.length > 0) && (
                        <div>
                            <h4>Selected Images</h4>
                            <Row gutter={[8, 8]}>
                                {[
                                    ...singleSelectedImages,
                                    ...multipleSelectedImages,
                                ].map((image) => (
                                    <Col key={image.id} span={8}>
                                        <Image
                                            src={image.src}
                                            alt={image.alt}
                                            style={{
                                                width: "150px",
                                                aspectRatio: 1,
                                                objectFit: "cover",
                                                borderRadius: 4,
                                            }}
                                            preview={false}
                                        />
                                    </Col>
                                ))}
                            </Row>
                        </div>
                    )}
                </div>

                <FontPicker
                    onChange={(font) => console.log("Selected:", font)}
                />

                <ThemeGenerator trigger={<Button>Theme Generator</Button>} />
                <ContentGenerator />

                <div style={{ height: "800px", width: "500px" }}>
                    <NewGenerationLoading />
                </div>
                <div style={{ height: "500px", width: "500px" }}>
                    <GenerationLoading />
                </div>
            </div>
            <Tweet />
        </QurealSection>
    );
}

export default Sandbox2;
